import { emptyArray } from 'vet-bones/constants';
import { SelectItem } from 'vet-bones/utils/select';

import { ReduxState } from 'src/store/types';
import { stringToSelectItem } from 'src/utils/select/stringToSelectItem';

export const databaseItemsSelector = (state: ReduxState): SelectItem[] => {
  const databaseIds = state.databases.databaseIds.filter(
    (databaseId) => state.databases.databasesById?.[databaseId]?.isOnline
  );

  return databaseIds.length
    ? databaseIds.map(stringToSelectItem)
    : (emptyArray as any);
};
